<template>
  <div @click="$emit('focusMap', true)">
    <div style=" position: relative;"></div>
    <GmapMap
      :center="center"
      :zoom="18"
      class="map-location"
      :options="{
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUI: true
      }"
    >
      <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="center = m.position"
      />

      <GmapMarker :position="center" :icon="markerOptions" />
    </GmapMap>

    <div v-show="markers" style="position: absolute;top: 130px;right: 0px;" @click="getLocation()">
      <button type="button" class="btn-icon-tracker">
        <img v-if="tracker" src="/img/icons/icon-tracker-active.png" width="25px" height="25px" />
        <img v-else src="/img/icons/icon-tracker.png" width="25px" height="25px" />
      </button>
    </div> 


    <div style="position: absolute;top: 0;left: 0px;">TEST 12312</div>
  </div>
</template>

<script>
import iconPin from '../../../../public/img/icons/icon.mypin.png'

export default {
  props: ['getMarkers'],
  data() {
    return {
      tracker: false,
      center: { lat: '', lng: '' },
      markerOptions: {
        url: iconPin,
        size: { width: 60, height: 90, f: 'px', b: 'px' },
        scaledSize: { width: 45, height: 45, f: 'px', b: 'px' }
      }
    }
  },

  computed: {
    markers() {
      return this.getMarkers ? this.getMarkers : []
    }
  },

  methods: {
    getLocation() {
      this.tracker = true
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          setTimeout(() => {
            this.tracker = false
          }, 500)
        },
        (error) => {
          console.log(error.message)
        }
      )
    }

    // geolocate: function() {
    //   this.tracker = true
    //   navigator.geolocation.getCurrentPosition((position) => {
    //     this.center = {
    //       lat: position.coords.latitude,
    //       lng: position.coords.longitude
    //     }

    //     if (position) {
    //       this.tracker = false
    //     }
    //   })
    // }
  },

  mounted() {
    this.$nextTick(function() {
      this.getLocation()
    })
  }
}
</script>

<style lang="scss" scoped>
.map-location {
  width: 100%;
  height: 1200px;
  position: relative;
}

.btn-icon-tracker {
  background: none rgb(255, 255, 255);
  border: 0px;
  margin: 10px;
  padding: 0px;
  text-transform: none;
  appearance: none;
  position: absolute;
  cursor: pointer;
  user-select: none;
  border-radius: 2px;
  height: 40px;
  width: 40px;
  box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
  overflow: hidden;
  top: 0px;
  right: 0px;
}
</style>
